import { Card, CardContent } from "@/shared/ui/card";

import type { GeoReport } from "../../../api/geoService";

const TYPE_LABELS: Record<string, string> = {
  encyclopedia: "百科",
  news: "新闻",
  qa_social: "问答/社交",
  video: "视频",
  government: "政务",
  official: "官方",
  other: "其它",
};
const AUTHORITY = new Set(["encyclopedia", "news", "government", "official"]);

/** AI 引用来源 Top 域名(真实搜索回溯)→ 内容投放优先级 + 权威来源率。 */
export function CitationSources({ report }: { report: GeoReport }) {
  const srcs = (report.citation_sources ?? []).slice(0, 8);
  if (srcs.length === 0) return null;
  const max = Math.max(...srcs.map((s) => s.count), 1);
  const estimated = (report.estimated_fields ?? []).includes("citation");
  const total = srcs.reduce((a, s) => a + s.count, 0);
  const authority = srcs
    .filter((s) => AUTHORITY.has(s.source_type ?? ""))
    .reduce((a, s) => a + s.count, 0);
  const hasTypes = srcs.some((s) => s.source_type);
  return (
    <Card>
      <CardContent className="p-6">
        <div className="text-sm font-medium">
          AI 引用来源 Top 域名
          {estimated && <span className="ml-2 text-xs font-normal text-amber-500">(估算值)</span>}
        </div>
        <div className="mt-1 text-xs text-muted-foreground">
          AI 回答该行业问题时都在引用谁 —— 内容优先投这些平台
          {hasTypes && total > 0 && (
            <span className="ml-2" data-testid="geo-authority-rate">
              权威来源占比 <b className="tabular-nums">{Math.round((authority / total) * 100)}%</b>
            </span>
          )}
        </div>
        <div className="mt-3 space-y-3" data-testid="geo-citation-list">
          {srcs.map((s) => (
            <div key={s.domain}>
              <div className="flex items-baseline justify-between text-sm">
                <span className="font-medium">
                  {s.domain}
                  {s.media && s.media !== s.domain && (
                    <span className="ml-1.5 text-xs font-normal text-muted-foreground">
                      {s.media}
                    </span>
                  )}
                  {s.source_type && (
                    <span className="ml-1.5 rounded border border-border px-1 text-2xs font-normal text-muted-foreground">
                      {TYPE_LABELS[s.source_type] ?? s.source_type}
                    </span>
                  )}
                </span>
                <span className="text-xs tabular-nums text-muted-foreground">{s.count} 次</span>
              </div>
              <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-muted">
                <div
                  className="h-full rounded-full bg-amber-500/80"
                  style={{ width: `${(s.count / max) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
